import {ReactNode, useEffect, useRef, useState} from 'react'
import {createPortal} from 'react-dom'

interface Props {
  children: ReactNode
}

const createPortalElement = () => {
  const el = document.createElement('div')
  return el
}

export const Portal = ({children}: Props) => {
  const [isHydrated, setIsHydrated] = useState(false)
  const elRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    setIsHydrated(true)

    if (!elRef.current) elRef.current = createPortalElement()

    const portalRoot = document.body as HTMLBodyElement
    portalRoot.appendChild(elRef.current!)
    return () => {
      portalRoot.removeChild(elRef.current!)
    }
  }, [])

  return isHydrated && elRef.current
    ? createPortal(children, elRef.current)
    : null
}
